import { format as dateFnsFormat, type Locale } from "date-fns";
import { es, enUS, it, ar, fr, pt, zhCN } from "date-fns/locale";
import i18n from "@/i18n/config";

// Bambara (bm) and Maninka (man) are not available in date-fns; fall back to French,
// the regional vehicular language in Mali / Guinea where these languages are spoken.
const localeMap: Record<string, Locale> = { es, it, ar, fr, pt, en: enUS, zh: zhCN, bm: fr, man: fr };

function getLocale(): Locale {
  return localeMap[i18n.language] || enUS;
}

/**
 * Format a date using the current i18n locale
 */
export function formatDate(date: Date | string, formatStr: string): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return dateFnsFormat(dateObj, formatStr, { locale: getLocale() });
}

// Predefined formats
export const formatDayShort = (date: Date) => formatDate(date, "EEE");
export const formatDayNumber = (date: Date) => formatDate(date, "d");
export const formatFullDate = (date: Date) => formatDate(date, "PPP");
export const formatDateTime = (date: Date) => formatDate(date, "PPP p");
export const formatDateLong = (date: Date) => formatDate(date, "EEEE, MMMM d, yyyy");
export const formatMonthYear = (date: Date) => formatDate(date, "MMMM yyyy");
